<template>
  <div v-if="show" class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-60" style="z-index: 9999; backdrop-filter: blur(4px);" @click.self="close">
    <div class="tw-bg-white dark:tw-bg-gray-900 tw-rounded-3xl tw-w-full tw-max-w-md tw-mx-4 tw-shadow-2xl tw-transform tw-transition-all tw-overflow-hidden">
      <!-- Decoración superior -->
      <div class="tw-h-2 tw-w-full tw-bg-gradient-to-r tw-from-[#18d600] tw-to-emerald-400"></div>
      
      <div class="tw-p-6 sm:tw-p-8 tw-text-center">
        <!-- Ícono -->
        <div class="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-16 tw-w-16 tw-rounded-full tw-bg-green-100 dark:tw-bg-green-900 tw-bg-opacity-30 tw-mb-6">
          <svg class="tw-h-8 tw-w-8 tw-text-[#18d600]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>

        <h3 class="tw-text-2xl tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-3">
          ¡Casi listo!
        </h3>
        
        <p class="tw-text-gray-600 dark:tw-text-gray-300 tw-text-base tw-mb-8 tw-leading-relaxed">
          Para continuar con tu compra y guardar tu progreso en la plataforma, necesitas acceder a tu cuenta o registrarte de forma gratuita.
        </p>

        <div class="tw-flex tw-flex-col tw-gap-3">
          <router-link 
            :to="{ name: 'Login' }" 
            class="tw-w-full tw-bg-[#18d600] hover:tw-bg-green-600 tw-text-white tw-font-bold tw-py-3 tw-px-4 tw-rounded-xl tw-transition-all tw-shadow-md hover:tw-shadow-lg tw-text-center"
          >
            Iniciar Sesión
          </router-link>
          
          <a 
            :href="crmUrl + '/register'" 
            class="tw-w-full tw-bg-white dark:tw-bg-gray-800 hover:tw-bg-gray-50 dark:hover:tw-bg-gray-700 tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-text-gray-900 dark:tw-text-white tw-font-bold tw-py-3 tw-px-4 tw-rounded-xl tw-transition-colors tw-text-center"
          >
            Crear cuenta nueva
          </a>
        </div>

        <div class="tw-mt-6">
          <button @click="close" class="tw-text-sm tw-font-medium tw-text-gray-500 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 tw-transition-colors">
            Cancelar y volver
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuestAuthModal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      crmUrl: process.env.VUE_APP_CRM_URL || "https://crm.promolider.info"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
